module.exports = "data:image/png;base64,"


//////////////////
// WEBPACK FOOTER
// ./src/images/review.png
// module id = 596
// module chunks = 0